<template>
  <section>
    <ods-module>
      <template slot="header">
        <list-header
            title="areasDefinition"
            btn-label="newArea"
            url-key="AreaDefinitionNew"
            :hasPermission=hasPermission
        />
      </template>

      <async-table
          :data="data"
          :total="total"
          :loading="loading"
          @fetchData="getData"
      >
        <ods-table-column prop="name" :label="$t('name')" v-if="hasPermission">
          <template slot-scope="scope">
            <router-link v-if="scope.row.id" :to="{ name: 'AreaDefinitionEdit', params: { id: scope.row.id }}">
              <ods-button type="text" class="p-0">{{scope.row.name}}</ods-button>
            </router-link>
          </template>
        </ods-table-column>
        <ods-table-column prop="name" :label="$t('name')" v-if="!hasPermission">
          <template slot-scope="scope">
            {{scope.row.name}}
          </template>
        </ods-table-column>

        <ods-table-column prop="active" :label="$t('active')">
          <template slot-scope="scope">
            <ods-icon name="checkmark-2" v-if="scope.row.active"></ods-icon>
            <ods-icon name="close" v-if="!scope.row.active"></ods-icon>
          </template>
        </ods-table-column>

        <ods-table-column align="right" v-if="hasPermission">
          <template slot-scope="scope">
            <table-delete @click="toggleDialog(scope.row.id)"></table-delete>
          </template>
        </ods-table-column>
      </async-table>

      <dialog-confirmation
          :visible="dialogVisible"
          :loading="deleteLoading"
          @confirm="deleteItem"
          @cancel="toggleDialog()"
      />
    </ods-module>
  </section>
</template>

<script>
import BalanceAreaService from '@/services/BalanceArea'
import handlePromise from '@/utils/promise'
import AsyncTable from '@/custom-components/AsyncTable'
import ListHeader from '@/custom-components/ListHeader'
import TableDelete from '@/custom-components/Buttons/TableDelete'
import DialogConfirmation from '@/custom-components/DialogConfirmation'
import asyncTableCommon from '@/mixins/async-table'
import { mapState } from 'vuex'

export default {
  name: 'AreaDefinitionDashboard',
  components: {
    AsyncTable,
    TableDelete,
    DialogConfirmation,
    ListHeader
  },
  computed: {
    ...mapState({
      userRole: state => state.userRoles.data
    })
  },
  mounted () {
    this.handlePermission()
  },
  mixins: [asyncTableCommon],
  data () {
    return {
      hasPermission: true,
      deleteLoading: false,
      dialogVisible: false,
      toDelete: null,
      promise: (params) => BalanceAreaService.getAreasWater(params)
    }
  },
  methods: {
    toggleDialog (id) {
      this.toDelete = id
      this.dialogVisible = !this.dialogVisible
    },
    async deleteItem () {
      this.deleteLoading = true

      const [error, response] = await handlePromise(BalanceAreaService.deleteAreaWater(this.toDelete))
      this.deleteLoading = false
      if (!response.ok) return this.$store.commit('settings/toggleAlert', this.$t(error))

      this.toggleDialog()
      this.getData(this.tableParams)
    },
    handlePermission () {
      let rolesArray = Object.values(this.userRole)
      rolesArray.map(role => {
        if (role === 'ROLE_OPERATOR') {
          this.hasPermission = false
          rolesArray.map(role2 => {
            if (role2 === 'ROLE_ADMIN') {
              this.hasPermission = true
            }
          })
          rolesArray.map(role2 => {
            if (role2 === 'ROLE_SUPER_ADMIN') {
              this.hasPermission = true
            }
          })
          rolesArray.map(role2 => {
            if (role2 === 'ROLE_MANAGER') {
              this.hasPermission = true
            }
          })
        }
      })
    }
  }
}
</script>
